import { render, staticRenderFns } from "./OptionInput.vue?vue&type=template&id=1ea03cb3&scoped=true&"
import script from "./OptionInput.vue?vue&type=script&lang=ts&"
export * from "./OptionInput.vue?vue&type=script&lang=ts&"
import style0 from "./OptionInput.vue?vue&type=style&index=0&id=1ea03cb3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea03cb3",
  null
  
)

export default component.exports